import { createUserIdentificationVerificationInfo } from 'constants/routes';
import { catchError, map, of, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { camelCaseObjectKeys } from 'utils/camelCase';
import { getAntiForgeryToken } from '../services/antiForgeryTokenService';

/**
 * Creates an observable for user identification verification information.
 *
 * @param {Object} params - The parameters for the API call.
 * @param {string} params.specId - The specification ID for the user.
 * @param {string} params.email - The email address of the user.
 * @param {string} params.identificationType - The type of identification being verified.
 * @returns {Observable<Object>} An observable that emits the response data or an error object.
 */
const createUserIdentificationVerificationInfo$ = ({ specId, email, identificationType }) =>
  fromFetch(createUserIdentificationVerificationInfo, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({ specId, email, identificationType }),
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    },
  }).pipe(
    switchMap(async (response) => {
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    map(camelCaseObjectKeys),
    catchError((error) => of({ error: true, message: error.message }))
  );

export default createUserIdentificationVerificationInfo$;
